import CoupleBtns from '@/components/UI/CoupleBtns';
import styles from './Home.module.css';
import Footer from '@/components/Footer';
import SummaryCard from '@/components/HomeArea/SummaryCard';
import { AuthContext } from '@/contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HomeSection from '@/components/HomeArea/HomeSection';
import catalogoImg from '@Images/section-catalog.jpg';
import formImg from '@Images/section-form.jpeg';
import rewardImg from '@Images/section-reward1.jpeg';
import homeBackgroundImg0 from '@Images/home0.jpg';
import homeBackgroundImg1 from '@Images/home1.jpg';
import homeBackgroundImg2 from '@Images/home2.jpg';
import homeBackgroundImg3 from '@Images/home3.jpg';
import homeBackgroundImg4 from '@Images/home4.jpg';
import Button from '@/components/UI/Button';
import { useNavigate } from 'react-router-dom';
import FaqContainer from '@/components/FAQArea/FaqContainer';
import Navbar from '@/components/Navbar';

const Home = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const authCtx = useContext(AuthContext);

	const isRoleAdmin = authCtx.role?.some((r) => r.name === 'ROLE_ADMIN');

	const backgroundImages = [
		homeBackgroundImg0,
		homeBackgroundImg1,
		homeBackgroundImg2,
		homeBackgroundImg3,
		homeBackgroundImg4
	];

	const [randomImg, setRandomImg] = useState('');

	useEffect(() => {
		const randomIndex = Math.floor(Math.random() * backgroundImages.length);
		setRandomImg(backgroundImages[randomIndex]);
	}, []);

	const titleBackgroundStyle = {
		backgroundImage: `linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0.8),
		rgba(255, 255, 255, 0.01)
		), url(${randomImg})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat'
	};

	return (
		<div className={styles.main_home_container}>
			<Navbar />

			<main className={styles.mainContent}>
				<div className={styles.background_title} style={titleBackgroundStyle}>
					<div className={styles.title_container}>
						<div className={styles.title}>{t('homePage.title').toUpperCase()}</div>
						<div className={styles.title_subtitle}>
							<p>{t('homePage.subtitle')}</p>
						</div>
					</div>
				</div>

				{!authCtx.isLoggedIn && (
					<div className={styles.background_description}>
						<div className={styles.description_container}>
							<div className={styles.descr_title_description}>
								<p>{t('homePage.titleDesc')}</p>
							</div>
							<div className={styles.descr_subtitle_description}>
								<p>{t('homePage.subtitleDesc')}</p>
							</div>
						</div>
					</div>
				)}

				{!authCtx.isLoggedIn && (
					<div className={styles.background_area_accessBtn_first}>
						<div className={styles.accessBtn_container}>
							<CoupleBtns
								className={styles.accessBtn}
								message={t('accessBtn.invitation')}
								onLeft={() => navigate('/login')}
								textLeft={t('accessBtn.loginBtn')}
								brightLeft={false}
								onRight={() => navigate('/signup')}
								textRight={t('accessBtn.signUpBtn')}
								brightRight={false}
							/>
						</div>
					</div>
				)}

				<div className={styles.background_area_cards}>
					<div className={styles.cards_container}>
						<SummaryCard />
					</div>
				</div>

				<div className={styles.background_area_sections_dark}>
					<div className={styles.sections_container}>
						<HomeSection
							title={t('homePage.catalog.title')}
							description={t('homePage.catalog.description')}
							description2={t('homePage.catalog.description2')}
							btnText={t('homePage.catalog.btnText')}
							backgroundImg={catalogoImg}
							imgLeftPosition={false}
							linkTo={authCtx.isLoggedIn ? '/catalog' : '/login'}
							bright={false}
						/>
					</div>
				</div>

				<div className={styles.background_area_sections_light}>
					<div className={styles.sections_container}>
						<HomeSection
							title={t('homePage.form.title')}
							description={t('homePage.form.description')}
							description2={t('homePage.form.description2')}
							btnText={t('homePage.form.btnText')}
							backgroundImg={formImg}
							imgLeftPosition={true}
							linkTo={authCtx.isLoggedIn ? (isRoleAdmin ? '/admin-area' : '/catalog') : '/login'}
							bright={true}
						/>
					</div>
				</div>

				<div className={styles.background_area_sections_dark}>
					<div className={styles.sections_container}>
						<HomeSection
							title={t('homePage.reward.title')}
							description={t('homePage.reward.description')}
							description2={t('homePage.reward.description2')}
							btnText={t('homePage.reward.btnText')}
							backgroundImg={rewardImg}
							imgLeftPosition={false}
							linkTo={authCtx.isLoggedIn ? (isRoleAdmin ? '/admin-area' : '/profile#rewards') : '/login'}
							bright={false}
						/>
					</div>
				</div>

				{!authCtx.isLoggedIn && (
					<div className={styles.background_area_accessBtn}>
						<div className={styles.accessBtn_container}>
							<CoupleBtns
								className={styles.accessBtn}
								message={t('accessBtn.invitation')}
								onLeft={() => navigate('/login')}
								textLeft={t('accessBtn.loginBtn')}
								brightLeft={true}
								onRight={() => navigate('/signup')}
								textRight={t('accessBtn.signUpBtn')}
								brightRight={true}
							/>
						</div>
					</div>
				)}

				<div className={styles.background_area_user}>
					<div className={styles.user_container}>
						<div className={styles.user_text}>
							<div className={styles.user_area_title}>{t('homePage.userArea.title')}</div>
							<div className={styles.user_area_description}>
								<p>{t('homePage.userArea.description')}</p>
							</div>
							<Button
								className={styles.userAreaBtn}
								name={t('homePage.userArea.btn')}
								onClick={() =>
									authCtx.isLoggedIn ? (isRoleAdmin ? navigate('/admin-area') : navigate('/profile')) : navigate('/login')
								}
								typeSubmit={'button'}
								color="black"
								background="white"
							/>
						</div>
						<div className={styles.user_image} />
					</div>
				</div>

				<div className={styles.background_area_faq}>
					<div className={styles.faq_container}>
						<FaqContainer />
					</div>
				</div>
			</main>

			<Footer />
		</div>
	);
};

export default Home;
